import { Component, OnInit } from '@angular/core';
import {SingleRatingPageService} from "../../../services/single-rating-page.service";

@Component({
  selector: 'app-rating-details-table',
  templateUrl: './rating-details-table.component.html',
  styleUrls: ['./rating-details-table.component.scss']
})
export class RatingDetailsTableComponent implements OnInit {

  public middleTableHeaderId = 'middleTableHeaderId';
  private _middleTableHeader: HTMLElement;
  constructor(
    private singleRatingPageService: SingleRatingPageService,
  ) { }



  ngOnInit(): void {
  }


  getRightPartHeaders() {
    return this.singleRatingPageService.rightPartHeaders;
  }

  getMiddlePartHeaders() {
    return this.singleRatingPageService.mutablePartHeaders;
  }

  getLeftPartHeaders() {
    return this.singleRatingPageService.leftPartHeaders;
  }

  getPlayersList() {
    return this.singleRatingPageService.listOfPlayers;
  }

  getPlayersStats() {
    return this.singleRatingPageService.statsList;
  }

  getTotalInfoList() {
    return this.singleRatingPageService.rightPartDataList;
  }

  getAllHeaderLabels() {
    return [...this.getLeftPartHeaders(), ...this.getMiddlePartHeaders(), ...this.getRightPartHeaders()];
  }
  getAllPlayersData() {
    return this.singleRatingPageService.rawPlayersDataList;
  }


  fullNameClickHandler($event) {
    $event.preventDefault();
  }


}
